import LegalLayout, { Section } from './LegalLayout';

const CONTACT_EMAIL = 'samuelmago7@gmail.com';

const PrivacyPage = () => {
  return (
    <LegalLayout
      title="Política de privacidad"
      subtitle="Cómo AliVan recopila, usa y protege tu información. Este documento aplica al uso de la aplicación web AliVan y a las integraciones oficiales conectadas por su titular."
      lastUpdated="Febrero 2026"
      testId="privacy-page"
    >
      <Section id="data-collected" title="1. Datos que recopilamos">
        <p>Para operar AliVan se recogen los siguientes datos, siempre limitados a lo estrictamente necesario:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><span className="text-white">Datos de cuenta</span>: nombre, correo electrónico y avatar público asociado a tu cuenta de Google al iniciar sesión.</li>
          <li><span className="text-white">Contenido de conversación</span>: mensajes, transcripciones de voz opcionales y archivos que subas para que AliVan pueda responderte.</li>
          <li><span className="text-white">Memoria persistente</span>: hechos que decidas guardar explícitamente para que AliVan los recuerde entre sesiones.</li>
          <li><span className="text-white">Configuración de proyectos</span>: nombres de proyectos, URLs públicas de perfiles sociales y tokens OAuth de las cuentas que enlaces voluntariamente.</li>
          <li><span className="text-white">Métricas técnicas mínimas</span>: registros anonimizados de errores y uso de límites de tasa para evitar abusos y costes desbocados.</li>
        </ul>
        <p>No vendemos ni compartimos datos personales con terceros distintos a los proveedores necesarios para operar el servicio.</p>
      </Section>

      <Section id="google-auth" title="2. Autenticación con Google">
        <p>El inicio de sesión utiliza el proveedor de autenticación de Google gestionado por Emergent. Al usarlo aceptas:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Que Google verifique tu identidad y comparta con AliVan tu nombre, correo y foto de perfil.</li>
          <li>Que la sesión se represente con una cookie segura de sesión almacenada en tu navegador.</li>
          <li>Que puedas cerrar sesión en cualquier momento y con ello se invalide el token del servidor.</li>
        </ul>
        <p>AliVan no almacena tu contraseña de Google. Nunca la ve, ni la puede ver.</p>
      </Section>

      <Section id="social-integrations" title="3. Integraciones con redes sociales">
        <p>Para funcionalidades opcionales de administración de canales, AliVan puede solicitar autorización OAuth oficial a:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><span className="text-white">YouTube (Google)</span>: lectura de metadatos del canal y estadísticas propias, mediante scopes <code>youtube.readonly</code> y <code>yt-analytics.readonly</code>.</li>
          <li><span className="text-white">TikTok</span>: integración pendiente de aprobación; se activará únicamente con tu consentimiento explícito.</li>
          <li><span className="text-white">Instagram (Meta)</span>: integración pendiente de aprobación; se activará únicamente con tu consentimiento explícito.</li>
        </ul>
        <p>Los tokens OAuth se guardan cifrados en la base de datos, aislados por usuario y por proyecto. Puedes revocarlos desde AliVan en cualquier momento pulsando <span className="text-white">Desconectar</span>, y adicionalmente desde el panel de seguridad del proveedor correspondiente.</p>
        <p>Ninguna publicación se envía a redes sociales sin tu confirmación explícita previa.</p>
      </Section>

      <Section id="cookies" title="4. Cookies">
        <p>AliVan utiliza cookies exclusivamente técnicas, no publicitarias:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li><span className="text-white">Sesión</span>: cookie <code>session_token</code> segura y HttpOnly para mantener tu inicio de sesión.</li>
          <li><span className="text-white">Preferencias</span>: en el almacenamiento local del navegador guardamos el estado del reproductor, el último session_id activo y otras preferencias no sensibles.</li>
        </ul>
        <p>No usamos cookies de terceros para publicidad, remarketing ni análisis de comportamiento externo.</p>
      </Section>

      <Section id="rights" title="5. Tus derechos">
        <p>Conforme al Reglamento General de Protección de Datos (RGPD) y normativas equivalentes, dispones de los siguientes derechos:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Acceso a los datos que AliVan almacena sobre ti.</li>
          <li>Rectificación de datos inexactos o incompletos.</li>
          <li>Supresión (derecho al olvido) de tu cuenta y de la memoria asociada.</li>
          <li>Portabilidad: exportación de tus conversaciones y memoria en formato estructurado.</li>
          <li>Oposición o limitación al tratamiento de determinados datos.</li>
          <li>Revocación del consentimiento en cualquier momento, sin efecto retroactivo sobre tratamientos previos legítimos.</li>
        </ul>
        <p>Para ejercer cualquiera de estos derechos escribe al correo de contacto indicado abajo. Responderemos en un plazo máximo de 30 días.</p>
      </Section>

      <Section id="retention" title="6. Retención y seguridad">
        <p>Los datos se conservan mientras tengas cuenta activa. Cuando solicites eliminación se borran conversaciones, memoria, tokens OAuth y perfil dentro de un plazo razonable, salvo obligación legal de conservar registros contables o de auditoría.</p>
        <p>Aplicamos límites de tasa, aislamiento por usuario en la base de datos y comunicaciones HTTPS obligatorias.</p>
      </Section>

      <Section id="contact-privacy" title="7. Contacto">
        <p>Para cualquier consulta sobre esta política o para ejercer tus derechos:</p>
        <p className="text-white">
          Correo: <a href={`mailto:${CONTACT_EMAIL}`} className="text-neon-red hover:underline" data-testid="privacy-contact-email">{CONTACT_EMAIL}</a>
        </p>
      </Section>
    </LegalLayout>
  );
};

export default PrivacyPage;
